import React from 'react';
import { Col, Container, Row, Nav, NavItem } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import uuid from 'react-uuid';
import '../../assets/css/componentStyles/AccountLayoutWrapper.css';

export const AccountLayoutTitleVariants = {
  PRIMARY: 'primary',
  ERROR: 'error',
  WARNING: 'warning',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
};

export function AccountLayoutWrapper({
  children,
  navOptions,
  navTitle,
  navContent,
  contentClassName,
}) {
  return (
    <Container
      fluid
      className="account-layout container-fluid d-flex flex-row p-0 flex-grow-1"
    >
      <div className="account-layout__nav-column d-none d-lg-block">
        <div className="account-layout__nav-column-content">
          {navTitle && (
            <Row className="m-0">
              <Col md={12} className="p-0 m-0 d-flex">
                {navTitle}
              </Col>
            </Row>
          )}
          {navOptions && (
            <Row
              className={`d-flex flex-column m-0 w-100 flex-grow-1 ${!navTitle ? 'mt-2' : ''}`}
            >
              <Col md={12} className="h-100 w-100 p-0">
                <Nav
                  vertical
                  className="settings-nav-container account-layout__nav d-flex flex-column flex-grow-1"
                >
                  {navOptions.map((item) => {
                    const navLink = React.Children.toArray(item.props.children)[0];
                    const className = navLink?.props?.className || '';
                    return (
                      <NavItem
                        key={item.key || uuid()}
                        className={className.includes('disabled') ? 'completed' : ''}
                      >
                        {item}
                      </NavItem>
                    );
                  })}
                </Nav>
              </Col>
            </Row>
          )}
          {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
          {navContent && <>{navContent}</>}
        </div>
      </div>
      <div className={`account-layout__content-column ${contentClassName || ''}`}>
        {children}
      </div>
    </Container>
  );
}

export function AccountLayoutNavItem({ children, link, onClick, hide, className }) {
  return (
    <NavItem className={`${hide ? 'hide' : ''}`}>
      <NavLink
        className={`account-layout__nav-item ${className || ''}`}
        to={link}
        onClick={onClick}
      >
        {children}
      </NavLink>
    </NavItem>
  );
}

export function AccountLayoutTitle({ children, variant }) {
  return (
    <div
      className={`nav-column__title-box d-flex justify-content-center align-items-center status-box box-${
        variant || AccountLayoutTitleVariants.PRIMARY
      }`}
    >
      {children}
    </div>
  );
}

export function AccountLayoutContentWrapper({ children }) {
  return <div className="account-layout__content-wrapper">{children}</div>;
}
